import ActivityLog from '@components/activityLog/ActivityLog'
import { useAppSelector } from '@store/hooks'
import { selectSelectedEventParticipation } from '@store/membership/EventParticipationReducer'
import { Spin } from 'antd'

const View = () => {
  const item = useAppSelector(selectSelectedEventParticipation())

  if (!item) {
    return <Spin />
  }

  return (
    <ActivityLog.Timeline
      entity="event-participation"
      entityId={item.id}
      cardProps={{
        style: { maxHeight: 500, overflow: 'scroll', padding: 10 },
      }}
    />
  )
}

export default View
